import React from 'react';

const StatusCellRenderer = ({value}) => {
    const status = value?.toUpperCase();
    return (
        <>
            {status === "PENDENTE" && <div className="well-status well danger">Pendente</div>}
            {status === "NEGADO" && <div className="well-status well warning">Negado</div>}
            {status === "BACKLOG" && <div className="well-status well-status-close">Backlog</div>}
            {status === "DOING" && <div className="well-status well-status-open">Doing</div>}
            {status === "CONCLUIDO" && <div className="well-status well-status-concluded">Concluído</div>}
            {status === "TRAVADO" && <div className="well-status well-status-travado">Travado</div>}
        </>
    );
};

export default StatusCellRenderer;